import { render, staticRenderFns } from "./ReasonFailGraduation.vue?vue&type=template&id=1c8042c5&"
import script from "./ReasonFailGraduation.vue?vue&type=script&lang=js&"
export * from "./ReasonFailGraduation.vue?vue&type=script&lang=js&"
import style0 from "./ReasonFailGraduation.vue?vue&type=style&index=0&id=1c8042c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports